import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_authenticated/dashboard/admin/presentation-templates",
)({
	beforeLoad: () => {
		throw redirect({ to: "/settings/org/presentation-templates" });
	},
});
